module.exports = require("file-source");



//////////////////
// WEBPACK FOOTER
// ../~/path-source/index.node.js
// module id = 1671
// module chunks = 2